module.exports = __webpack_public_path__ + "media/images/lig/icon-plus-4c0865ed2a86be9de0ab0b089d8c5766.svg";